import {
  Button,
  Text,
  TextInput,
  CopyButton,
  Tooltip,
  Modal,
} from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { getInviteUrl } from "./utils";

interface InviteClientsModalProps {
  openedModal: boolean;
  close: () => void;
}

// Invite Client Modal
const InviteClientsModal = ({
  openedModal,
  close,
}: InviteClientsModalProps) => {
  return (
    <Modal
      className="client-modal"
      opened={openedModal}
      centered
      onClose={close}
      title="Invite a Client"
      padding="lg"
    >
      <Text className="share" mt="sm">
        Share Invite Link With Clients
      </Text>
      <span className="invite-link-copy">
        <TextInput value={getInviteUrl()} readOnly style={{ width: "100%" }} />
        <CopyButton value={getInviteUrl()}>
          {({ copied, copy }) => (
            <Tooltip
              label={copied ? "Copied" : "Copy"}
              withArrow
              position="top"
            >
              <Button
                className="copy"
                color={copied ? "teal" : "blue"}
                onClick={copy}
              >
                {copied ? <IconCheck /> : <IconCopy />}
              </Button>
            </Tooltip>
          )}
        </CopyButton>
      </span>
    </Modal>
  );
};

export default InviteClientsModal;
